import React, { useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import "./Verify_Profile_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp } from "@fortawesome/free-solid-svg-icons";
import { updateIdentityImage } from "../../../../utils/apis/login/Login";
import { useNavigate } from "react-router-dom";
import Successfull_Modal from "../successfull_modal/Successfull_Modal";
import Success_Lottie from "../../../animation/success_lottie/Success_Lottie";
const Verify_Profile_Modal = (props) => {
  const [identityImage, setIdentityImage] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIdentityImage(file);
      setPreviewUrl(URL.createObjectURL(file));
      setError("");
    }
  };

  const onSubmit = async () => {
    if (!identityImage) {
      setError("Please upload an identity image.");
      return;
    }

    const finalData = new FormData();
    finalData.append("identity_image", identityImage);

    try {
      const res = await updateIdentityImage(finalData);

      if (res?.success) {
        props?.onHide();
        setShowSuccessModal(true);
        setTimeout(() => {
          navigate("/my-account");
          setShowSuccessModal(false);
        }, 5000);

        if (props?.setFormSubmitted) {
          props?.setFormSubmitted(true);
        }

        if (props?.setStepCompleted) {
          props?.setStepCompleted(true);
        }
      } else {
        setError("Failed to update identity image. Please try again.");
      }
    } catch (error) {
      console.error("Error updating identity image:", error);
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <section className="Verify_Profile_Modal">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Verify_Profile_Modal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Verify Your Profile With Identification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="note_div">
            <p className="note">Verify Your Profile With ID </p>
            <p className="note">To Build Authenticity And Security Online.</p>
          </div>

          <div className="upload_div">
            <Form.Label>Upload Your Attachment</Form.Label>
            <InputGroup className="upload_input_group mb-3">
              <Form.Control
                placeholder="Attach Id In Format JPEG, PDF"
                aria-label="Attach file"
                aria-describedby="basic-addon2"
                type="file"
                className="file_input"
                onChange={handleFileChange} // Handle file input change
              />
              <InputGroup.Text id="basic-addon2" className="upload_icon_holder">
                <FontAwesomeIcon icon={faCloudArrowUp} />
              </InputGroup.Text>
            </InputGroup>
            {error && <p className="text-danger">{error}</p>}{" "}
            {/* Display error message */}
            {previewUrl && (
              <div className="image_preview mt-3">
                <img
                  src={previewUrl}
                  alt="Preview"
                  className="img-fluid"
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                />
              </div>
            )}{" "}
            {/* Display image preview */}
          </div>

          <div className="btn_holder">
            <Orange_White_Border_Btn btn_name="Submit" onClick={onSubmit} />
          </div>

          <p
            className="do_it_text"
            onClick={() => {
              props?.onHide();
            }}
          >
            Do It Later
          </p>
        </Modal.Body>
      </Modal>
      <Successfull_Modal
        message="Profile Doc Send For Verification Successfully"
        show={showSuccessModal}
        onHide={() => {
          setShowSuccessModal(false);
        }}
        lottie={<Success_Lottie />}
      />
    </section>
  );
};

export default Verify_Profile_Modal;
